import React from "react";
import World from "./../World/World";
import CountryList from "./../Countries/CountryList";
import News from "./../News/News";

const Home = () => {
  return (
    <div style={{ display: "flex" }}>
      <World/>
      <News/>
      <CountryList/>
    </div>
  );
};

export default Home;
